export const EMAIL_ADDRESS_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

const getErrorMessage = (error: unknown): string | null => {
  if (!error || typeof error !== 'object' || !('message' in error)) return null;

  const { message } = error as { message?: unknown };
  return typeof message === 'string' ? message : null;
};

export const getFieldErrorMessages = (error: unknown): string[] => {
  if (Array.isArray(error)) {
    return error.map(getErrorMessage).filter((message): message is string => Boolean(message));
  }

  const message = getErrorMessage(error);
  return message ? [message] : [];
};
